import {domainSeparationProperties, memoize, kebabCase} from '@servicenow/ui-internal';

const toAttributeName = memoize(
	function toAttributeName(propName) {
		return kebabCase(propName);
	},
	{profileName: 'effect-helpers-toAttributeName'}
);

const {NOW_DS_DOMAIN_ID, NOW_DS_DOMAIN_SCOPE, NOW_DS_RECORD_ID, NOW_DS_RECORD_TABLE} =
	domainSeparationProperties;

function isValidRecordArgument(table, id) {
	return table && id;
}

function getDomainProp(el, name) {
	return el[name] || (el.getAttribute && el.getAttribute(toAttributeName(name)));
}

function createDomainContextProperty(el) {
	const table = getDomainProp(el, NOW_DS_RECORD_TABLE);
	const sysId = getDomainProp(el, NOW_DS_RECORD_ID);
	const domain = getDomainProp(el, NOW_DS_DOMAIN_ID);
	const scope = getDomainProp(el, NOW_DS_DOMAIN_SCOPE);
	const domainContext = {
		...(isValidRecordArgument(table, sysId) && {
			[NOW_DS_RECORD_TABLE]: table,
			[NOW_DS_RECORD_ID]: sysId
		}),
		...(domain && {
			[NOW_DS_DOMAIN_ID]: domain
		}),
		...(scope && {
			[NOW_DS_DOMAIN_SCOPE]: scope
		})
	};
	return hasDomainProps(domainContext) ? domainContext : undefined;
}

export function getSeismicHoistTargetFor(seismicHoistElement) {
	return seismicHoistElement.sourceElement;
}

function isSeismicHoistElement(el) {
	return el.tagName === 'SEISMIC-HOIST';
}

/**
 * Element contains a reserved domain separation property
 *
 * @param el
 * @return boolean
 */
function hasDomainProps(el) {
	return !!(
		(getDomainProp(el, NOW_DS_RECORD_TABLE) && getDomainProp(el, NOW_DS_RECORD_ID)) ||
		getDomainProp(el, NOW_DS_DOMAIN_ID) ||
		getDomainProp(el, NOW_DS_DOMAIN_SCOPE)
	);
}

/**
 *
 * @param element
 * @returns Object|undefined
 */
export default function resolveDomainContext(element) {
	let el = element;
	while (el) {
		if (!isSeismicHoistElement(el) && hasDomainProps(el)) return createDomainContextProperty(el);
		el = isSeismicHoistElement(el) ? getSeismicHoistTargetFor(el) : el.parentNode || el.host;
	}
	return undefined;
}
